import { TransparencyBlock } from './Block'
import { ITransparencyItem } from './Transparency.types'
import cn from 'classnames'

interface ITransparencyList {
  transparencyList: ITransparencyItem[]
}

export function TransparencyList({ transparencyList }: ITransparencyList) {
  return (
    <div
      className={cn(
        'relative pt-16 m-0 md:flex md:pt-[72px] lg:-mx-[26px]',
        "after:content-none lg:after:content-[''] after:top-[132px] after:-left-[46px] after:w-[28px] after:h-[693px]",
        "after:absolute after:bg-contain after:bg-[url('/aboutus/circle-style.png')] after:bg-no-repeat"
      )}
    >
      {transparencyList.map((item, index) => (
        <TransparencyBlock
          key={index}
          transparency={item}
          headingClassName={cn({
            'text-eco-khaki': index === 0,
            'text-acai': index === 1,
            'text-pitaya': index === 2,
          })}
        />
      ))}
    </div>
  )
}
